<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('q58')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />
        <div v-else class="item_list" v-for="(v,key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ size }}</span>
              <span class="ressquareBox">{{ double }}</span>
             
            </div>
          
            </div>
          </div>
          <div class="topInfo">
        
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',
      size:""
      
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res=>{
        if(res.code === 200){
          const lanng = localStorage.getItem("lang");
          this.list = res.data;
          // 
          this.list.forEach(item => {
          const sum = item.opencode[0] + item.opencode[1] + item.opencode[2];
            if(sum >= 11 && sum <=18){
            lanng == 'zh'? this.size = '玫瑰':lanng == 'en'? this.size = 'Rose':lanng == 'ja'? this.size = 'ロケット':this.size = '장미'
          }else if(sum >= 3 && sum <= 10){
              lanng == 'zh'? this.size = '百合':lanng == 'en'? this.size = 'Lily':lanng == 'ja'? this.size = "ハート":this.size = '백합'
          }
          if(sum % 2 === 0){
            lanng == 'zh'? this.double = "氣球":lanng == 'en'? this.double = "Balloon":lanng == 'ja'? this.double = "バラ":this.double = "풍선";
          }else {
            lanng == 'zh'? this.double = "煙花":lanng == 'en'? this.double = "fireworks":lanng == 'ja'? this.double = "ヨット":
              this.double = "불꽃놀이";
          }
          })
         console.log(this.size, this.double,998);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      // this.getUserGameList();
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #1f1c1f;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  line-height: 60px;
  color: #f3c7a2;
  border: 1px solid #766350;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #f3c7a2;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #f3c7a2;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #f3c7a2;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #f3c7a2;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}
</style>
